import { createSelector } from "@reduxjs/toolkit";
import { IRootState } from "../app/store";
import { selectHttpMcbimSpacesResult } from "../McBim/mcbimSelectors";

export const selectedSpaceNumber = (state: IRootState) => state.design.selectedSpaceNumber;

